<template>
  <v-row>
    <v-col cols="12" md="6">
      <div class="pa-2 bordered rounded bg-grey_3">
        <div class="text-h6 font-weight-bold my-2 text-darkblue">Paiements encaissés</div>
        <div v-for="(paiements, type_paiements) in finances.paiements" :key="type_paiements">
          <div class="text-body">{{ type_paiements }}: {{ paiements.prix_apres_remise }}€</div>
        </div>
        <div v-if="finances.paiements && Object.keys(finances.paiements).length == 0">
          <div class="text-body">Aucun paiement encaissé par l'organisation</div>
        </div>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <div class="pa-2 bordered rounded bg-grey_3">
        <div id="containerFinanceOrgaGraph" style="height: 300px"></div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";
import Highcharts from "highcharts";
export default {
  data() {
    return {
      finances: {},
      categories: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
    total_inscription() {
      let total = 0;
      for (let item in this.finances.inscriptions) {
        total += parseFloat(this.finances.inscriptions[item].total);
      }
      return total;
    },
    total_option() {
      let total = 0;
      for (let item in this.finances.options) {
        total += parseFloat(this.finances.options[item].total);
      }
      return total;
    },
  },
  methods: {
    async get() {
      let req = await AdminService.getFinancesOrga(this.mainStore.module.id);
      if (req) {
        this.finances = req;
        this.build_chart();
      }

    },
    build_chart() {
      let series_data = [];
      for (let item in this.finances.inscriptions) {
        this.categories.push(this.finances.inscriptions[item].item);
        let total = parseFloat(this.finances.inscriptions[item].quantite.toFixed(2));
        series_data.push(total);
      }
      for (let item in this.finances.options) {
        this.categories.push(this.finances.options[item].item);
        let total = parseFloat(this.finances.options[item].quantite.toFixed(2));
        series_data.push(total);
      }

      Highcharts.chart("containerFinanceOrgaGraph", {
        chart: {
          type: "column",
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        title: {
          text: "Nombre d'inscriptions par l'organisateur",
          align: "left",
          verticalAlign: "top",
        },
        yAxis: {
          title: {
            text: "Quantité",
          },
        },
        xAxis: {
          categories: this.categories,
        },
        legend: {
          enabled: true,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "€",
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },
          },
        },

        series: [
          {
            name: "Total",
            data: series_data,
          },
        ],
      });
    },
  },
  async created() {
    await this.get();
  },
};
</script>

<style lang="scss" scoped></style>